import React from "react";
import {
  FaReceipt,
  FaTimes,
  FaSpinner,
  FaExclamationTriangle,
} from "react-icons/fa";

const PosCloseModal = ({
  countedCash,
  setCountedCash,
  onClose,
  onSubmit,
  isSubmitting,
  shiftError,
}) => {
  return (
    <div className="fixed inset-0 z-[7000] bg-slate-950/80 backdrop-blur-md flex items-center justify-center p-4">
      <div className="w-full max-w-md bg-slate-900 border border-white/10 rounded-2xl p-6 shadow-2xl text-slate-100 flex flex-col gap-4">
        <div className="flex justify-between items-center">
          <h3 className="text-sm font-bold text-white tracking-wide uppercase flex items-center gap-2">
            <FaReceipt className="text-red-400" /> Reconcile & End Shift
          </h3>
          <button
            type="button"
            onClick={onClose}
            className="p-1.5 rounded-lg bg-white/5 text-slate-400 hover:text-white transition"
          >
            <FaTimes className="text-xs" />
          </button>
        </div>
        <p className="text-[11px] text-slate-500">
          Count all cashesin the drawer
        </p>
        <form onSubmit={onSubmit} className="flex flex-col gap-4">
          <div className="flex flex-col gap-1.5">
            <label className="text-[10px] uppercase font-bold tracking-wider text-slate-400">
              Total Counted Cash (ETB)
            </label>
            <input
              type="number"
              step="0.01"
              min="0"
              required
              autoFocus
              value={countedCash}
              onChange={(e) => setCountedCash(e.target.value)}
              placeholder="0.00"
              className="w-full bg-slate-950 border border-white/10 rounded-xl px-3 py-2.5 text-amber-400 font-mono font-bold text-sm focus:outline-none focus:border-red-500/50"
            />
          </div>

          {shiftError && (
            <p className="text-[11px] text-red-400 flex items-center gap-1.5">
              <FaExclamationTriangle /> {shiftError}
            </p>
          )}

          <div className="flex gap-2">
            <button
              type="button"
              onClick={onClose}
              className="flex-1 py-2.5 bg-white/5 hover:bg-white/10 text-slate-300 text-xs font-bold rounded-xl transition uppercase"
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={isSubmitting}
              className="flex-1 py-2.5 bg-red-600 hover:bg-red-500 text-white font-bold text-xs rounded-xl transition uppercase flex items-center justify-center gap-2"
            >
              {isSubmitting ? (
                <FaSpinner className="animate-spin" />
              ) : (
                "Confirm Close"
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default PosCloseModal;
